import address from 'plugins/i18n/entity/address.de.ts'

const unit = {
	name: 'Einheit | Einheiten',
	icon: 'fa-thin fa-building',
	fields: {
		hp_id: 'ID',
		position: 'Einheit',
		building: {
			address: {
				street: '',
			},
		},
		area: 'Größe',
		is_unit: 'Wohnung',
		commercial: 'Gewerbe',
	},
}

export default unit
